import useSWR from 'swr';
import {
	getAllCrops,
	getAllMonitoringCrops,
	getCropsByIds,
	getCropsByIdsPost,
} from './cropsService';
import { useCropsStore } from './cropsStore';

export function useCrops() {
	const { setCrops } = useCropsStore();

	return useSWR('crops', getAllCrops, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		onSuccess: (crops) => {
			setCrops(crops);
		},
	});
}

export function useMonitoringCrops() {
	const { setCropsMonitoring } = useCropsStore();

	return useSWR('crops', getAllMonitoringCrops, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		onSuccess: (crops) => {
			setCropsMonitoring(crops);
		},
	});
}

export function useCropsByIds() {
	const { setCropsByIds } = useCropsStore();

	const { mutate, isValidating, ...rest } = useSWR('cropsByIds', null, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
	});

	const fetchCropsByIds = async (ids: string[]) => {
		const result = await getCropsByIds(ids);

		setCropsByIds(result);
		await mutate(result, false);

		return result;
	};

	return { ...rest, fetchCropsByIds, isLoading: isValidating };
}

export function useCropsByIdsPost() {
	const { setCropsByIds } = useCropsStore();

	const { mutate, isValidating, ...rest } = useSWR('cropsByIds', null, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
	});

	const fetchCropsByIds = async (ids: string[]) => {
		const result = await getCropsByIdsPost(ids);

		setCropsByIds(result);
		await mutate(result, false);

		return result;
	};

	return { ...rest, fetchCropsByIds, isLoading: isValidating };
}
